export default __webpack_public_path__ + "static/media/alphabet-yellow-v.32de2bd7.png";